"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var asg_1 = require("@alinta-digital/asg");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var StyledBoxRateItemLeft = (0, styled_components_1.default)(asg_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  flex-shrink: 1;\n"], ["\n  flex-grow: 1;\n  flex-shrink: 1;\n"])));
var StyledBoxRateItemRight = (0, styled_components_1.default)(asg_1.Box)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex-grow: 2;\n  flex-shrink: 0;\n  text-align: right;\n  align-self: center;\n"], ["\n  flex-grow: 2;\n  flex-shrink: 0;\n  text-align: right;\n  align-self: center;\n"])));
var RateItem = function (_a) {
    var label = _a.label, value = _a.value, lastItem = _a.lastItem;
    var borderBottom = lastItem ? undefined : 'bottom';
    return (react_1.default.createElement(asg_1.Box, { pad: { vertical: '8px', horizontal: '5px' }, border: borderBottom, direction: "row", justify: "between" },
        react_1.default.createElement(StyledBoxRateItemLeft, { pad: { right: '5px' } },
            react_1.default.createElement(asg_1.Text, { size: "medium", weight: 500 }, label)),
        react_1.default.createElement(StyledBoxRateItemRight, null,
            react_1.default.createElement(asg_1.Text, { size: "medium", weight: 500 }, value))));
};
var PlanRates = function (_a) {
    var rates = _a.rates;
    var items = [
        { label: 'Daily Supply Charge', value: rates.dailySupplyCharge },
        { label: 'Peak Consumption', value: rates.peakConsumption },
        { label: 'Off Peak Consumption', value: rates.offPeakConsumption },
        { label: 'Controlled Load Consumption', value: rates.controlledLoadConsumption },
    ];
    return (react_1.default.createElement(asg_1.Box, { flex: true, direction: "column" },
        react_1.default.createElement(asg_1.Box, { pad: { vertical: '8px', horizontal: '5px' }, border: "bottom", direction: "row", justify: "between", background: asg_1.colors['secondaryBlue-2'] },
            react_1.default.createElement(asg_1.Text, { size: "medium", weight: 900 }, "Electricity"),
            react_1.default.createElement(asg_1.Text, { size: "medium" }, "Tariff (inc. GST)")),
        items.map(function (item, index) { return (react_1.default.createElement(RateItem, { key: index, label: item.label, value: item.value, lastItem: index === items.length - 1 })); })));
};
exports.default = PlanRates;
var templateObject_1, templateObject_2;
//# sourceMappingURL=PlanRates.js.map